import { useDesktopView } from 'utils/hooks/useDesktopView'

/**
 * Controls whether the desktop responsive layout is active for /video-inspirasi pages.
 *
 * Shares the same Toggle SDK key as ide-praktik since both features are part
 * of the same content ecosystem.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at >=768px
 */
export const useVideoInspirasiDesktopView = () =>
  useDesktopView('ide-praktik-desktop-view-enabled')
